import { apiClient } from "@/lib/api";

export const prepOverview = () => apiClient.get("/prep/overview");
export const prepGenerate = (track, count = 5) => apiClient.post("/prep/generate", { track, count });
export const prepSubmit = (track, results) => apiClient.post("/prep/submit", { track, results });
export const prepLeaderboard = () => apiClient.get("/prep/leaderboard");
